import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const EvolveToCyborgTshirtBlackProduct = {
  title: "'Evolve to Cyborg' Black T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/evo-to-cyborg-tee-black.png/w_1920',
  shopifyProductName: 'Evolve to Cyborg T-shirt',
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const EvolveToCyborgTshirtBlackShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691325419762',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325419762:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691325681906',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325681906:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691325747442',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325747442:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691325812978',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325812978:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691325878514',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325878514:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200406073440',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406073440:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200406138976',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406138976:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200406204512',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406204512:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200406270048',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406270048:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200406335584',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406335584:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718621114428',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621114428:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718621179964',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621179964:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718621245500',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621245500:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718621311036',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621311036:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718621376572',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621376572:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737965211718',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965211718:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737965277254',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965277254:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737965342790',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965342790:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737965408326',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965408326:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737965473862',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965473862:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202718966078',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718966078:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202719031614',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719031614:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202719097150',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719097150:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202719195454',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719195454:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202719260990',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719260990:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
